import Link from "next/link";
import PropTypes from "prop-types";
import { Component } from "react";
import classNames from 'classnames';
import {
  formToggleCard,
  mAlignCenter,
  formSubmitButton,
} from "@/assets/styles/common.module.scss";
// import { API_URLS } from '@/config';
import { textStyle, headerClass } from './pol-gen-progress.module.scss';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    console.error({ error, errorInfo });
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // return (
      //   <div className="flexCenter">
      //     <h2>Oops, there is an error!</h2>
      //     <button
      //       type="button"
      //       onClick={() => this.setState({ hasError: false })} >
      //       <Link href="/">Go to homepage</Link>
      //     </button>
      //   </div>
      // );

      return (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <article className={classNames("rFormCard", formToggleCard)}>
                <div
                  className={classNames(
                    "px-5 d-flex flex-column pt-sm-2 pt-md-5 align-self-center",
                    mAlignCenter
                  )}
                >
                  <h3 className={classNames("mb-4 align-self-center", headerClass)}>
                    Oops, there is an error!
                  </h3>

                  <span className={classNames(textStyle, "align-self-center")}>
                    Please login again to continue
                  </span>

                  <span className={classNames(textStyle, "align-self-center")}>
                    Call <strong>18002667780</strong> for any assisstance.
                  </span>
                  <div
                    className="my-3 d-flex align-self-stretch"
                    style={{ border: "1px solid #cdcdcd" }}
                  />
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className={classNames(
                        "btn rounded-pill col-md-10 col-sm-12 mt-2 mb-3 mr-auto",
                        formSubmitButton
                      )}
                      onClick={() => {
                        this.setState({ hasError: false });
                        window.location.href = '/';
                      }}
                    >
                      Go to homepage
                    </button>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};

export default ErrorBoundary;
